import { RootState } from "../store";

export const getConfluenceDocumentLinks = (state: RootState) => {
    return state.informationLinksReducer.confluenceDocumentLinks;
};
